import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Registra el Service Worker (Cache-First con Workbox).
// Solo se activa en producción (`npm run build`).
serviceWorkerRegistration.register({
  onSuccess: () => console.log("[SW] App lista para uso offline."),
  onUpdate: (registration) => {
    // Notifica al usuario que hay una nueva versión disponible.
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  },
});

reportWebVitals();
